import { render, staticRenderFns } from "./topics-list-panel.vue?vue&type=template&id=a42fa04e&scoped=true"
import script from "./topics-list-panel.ts?vue&type=script&lang=ts&external"
export * from "./topics-list-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./topics-list-panel.scss?vue&type=style&index=0&id=a42fa04e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42fa04e",
  null
  
)

export default component.exports